if (!customElements.get('size-chart')) {
  customElements.define(
    'size-chart',
    class SizeChart extends HTMLElement {
      constructor() {
        super();

        /** @type {HTMLSelectElement | null} */
        this.select = this.querySelector('[data-size-chart-head-select]');

        /** @type {HTMLElement[]} */
        this.values = Array.from(this.querySelectorAll('[data-size-chart-head-value]'));
      }

      connectedCallback() {
        this.select?.addEventListener('change', this.handleChange.bind(this));
      }

      handleChange() {
        for (const value of this.values) {
          value.dataset.selected = String(value.dataset.sizeChartHeadValue === this.select?.value);
        }
      }
    },
  );
}
